export const paramToMaterial = param => {
  const decodedParam = decodeURIComponent(param);
  const material = decodedParam.split("_").slice(0, -1).join(" ");
  return material.charAt(0).toUpperCase() + material.slice(1);
};

export const materialToParam = material => `${material.split(" ").join("_").toLowerCase()}_range`;
